// src/App.js
// Auth gate — checks if user is signed in via MSAL.
// If signed in: renders the MSP Operating System app.
// If not signed in: renders the LoginPage.
// The MSP OS app component goes where indicated below —
// paste your msp-os.jsx content into MspOs.js

import React, { useEffect, useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import LoginPage from "./components/LoginPage";
import MspOs from "./components/MspOs";

export default function App() {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, accounts } = useMsal();
  const [userInfo, setUserInfo] = useState(null);

  // Set user info once authenticated
  useEffect(() => {
    if (isAuthenticated && accounts.length > 0) {
      setUserInfo({
        name: accounts[0].name,
        email: accounts[0].username,
      });
    }
  }, [isAuthenticated, accounts]);

  // While MSAL is processing a redirect — show nothing to avoid flicker
  if (inProgress === InteractionStatus.HandleRedirect) {
    return null;
  }

  // Not signed in — show login page
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // Signed in — show the full MSP OS app
  return <MspOs userInfo={userInfo} />;
}